var _rect, _rect2, _rect3, _path, _path2, _g, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AddAlert_Outline_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1194",
    "data-name": "Rectangle 1194",
    width: 24,
    height: 24,
    fill: "#165cf3",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1195",
    "data-name": "Rectangle 1195",
    width: 22,
    height: 22,
    transform: "translate(0.94 1)",
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 22,
    height: 22,
    transform: "translate(0.94 1)",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M20.68,14.85l-3.41-5.7",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M14.95,5.28l-1.26-2.1a1.976,1.976,0,0,0-2.72-.67,2.043,2.043,0,0,0-.67.67L1.9,17.21a1.982,1.982,0,0,0,.73,2.71,2.081,2.081,0,0,0,.97.27H15.67",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3290",
    "data-name": "Group 3290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M11.24,8.8,7.76,14.61a.82.82,0,0,0,.3,1.12.8.8,0,0,0,.4.11h6.96a.817.817,0,0,0,.81-.83.8.8,0,0,0-.11-.4L12.64,8.8a.823.823,0,0,0-1.41,0Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    y2: 1.64,
    transform: "translate(11.94 10.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x2: 0.01,
    transform: "translate(11.94 14.2)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(15.66 6.69)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "add-circle",
    d: "M18.6,13.69a4.5,4.5,0,1,0,4.5,4.5,4.494,4.494,0,0,0-4.5-4.5Zm1.73,4.85H18.95v1.38a.35.35,0,1,1-.7,0V18.54H16.87a.35.35,0,0,1,0-.7h1.38V16.46a.35.35,0,1,1,.7,0v1.38h1.38a.35.35,0,1,1,0,.7Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsBtnIcon);
export default __webpack_public_path__ + "static/media/alerts-btn-icon.97d50816ab4c33a4fa8b7d7c642a90c5.svg";
export { ForwardRef as ReactComponent };